<template>
  <div :class="['simpleCard', { mini }, { isList }]">
    <a
      :href="url ? url : path"
      :target="url ? '_blank' : ''"
      :rel="url ? 'noopener' : ''"
      @click="clickA"
    >
      <div class="simpleCard_img">
        <img :src="image" :alt="imageAlt" />
      </div>
      <div class="simpleCard_body">
        <p class="simpleCard_category">{{ category }}</p>
        <h3 class="simpleCard_heading">{{ heading }}</h3>
        <p
          class="simpleCard_description"
          v-if="!mini && !isList && description"
        >
          {{ description }}
        </p>
      </div>
    </a>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'

export default defineComponent({
  name: 'SimpleCard',

  props: {
    image: String,
    imageAlt: {
      type: String,
      default: ''
    },
    category: String,
    heading: String,
    description: String,
    url: String,
    mini: {
      type: Boolean,
      default: false
    },
    isList: {
      type: Boolean,
      default: false
    },
    path: {
      type: String,
      default: '/'
    }
  },

  setup(props) {
    const router = useRouter()

    const clickA = (e: any) => {
      if (props.url) return true
      if (e.ctrlKey || e.metaKey) return true

      e.preventDefault()
      return router.push(props.path)
    }

    return {
      clickA
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.simpleCard {
  line-height: 1.78;
  a {
    display: block;
    width: 100%;
  }
  img {
    width: 100%;
  }
}

.simpleCard_category {
  margin-top: 10px;
  font-size: 1.4rem;
  color: var.$color-main-text;
}

.simpleCard_heading {
  line-height: 1.3;
  font-size: 2rem;
  font-weight: 500;
  & + p {
    margin-top: 10px;
  }
}

.simpleCard.mini {
  .simpleCard_category {
    font-size: 1.2rem;
    margin-top: 0;
  }

  .simpleCard_heading {
    font-size: 1.5rem;
  }

  @include mixins.media() {
    a {
      display: flex;
      align-items: center;
    }

    .simpleCard_img {
      flex: 0 0 100px;
      margin-right: 15px;
    }

    .simpleCard_heading {
      font-size: 1.4rem;
    }
  }
}
.simpleCard.isList {
  a {
    display: flex;
    padding: 20px 0;
  }
  .simpleCard_img {
    flex: 0 0 120px;
    margin-right: 15px;
  }
  .simpleCard_category {
    margin-top: 0;
    line-height: 1.5;
    font-size: 1.2rem;
  }
  .simpleCard_heading {
    font-size: 1.5rem;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
  & + .isList {
    border-top: 1px solid #e4e4e4;
  }
  @include mixins.media() {
    a {
      padding: 24px 0;
      align-items: center;
    }
    .simpleCard_img {
      flex: 0 0 180px;
    }
    .simpleCard_category {
      font-size: 1.4rem;
    }
    .simpleCard_heading {
      font-size: 2rem;
    }
  }
}
.simpleCard_description {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
</style>
